import $ from 'jquery';
import autocomplete from 'autocompleter';

const searchForm = document.getElementById('search-form');
const $searchWrap = $('.site-header__search');

$('.toggle-search').click(() => {
    $searchWrap.toggleClass('active');
});

if(searchForm) {
    const searchFormInput = searchForm.querySelector('input[type="search"]');
    const searchFormResults = searchForm.querySelector('search-form__suggestions');

    autocomplete({
        input: searchFormInput,
        showOnFocus: true,
        fetch: function (text, update) {
            update([
                {
                    title: 'Searching...',
                    excerpt: '',
                },
            ]);
            $.ajax({
                method: 'POST',
                url: wp.ajax,
                data: {
                    action: 'get_search_autocomplete',
                    search: text,
                }
            })
            .done(data => {
                let results = JSON.parse(data);

                console.log(results);
                update(results);
            });
        },
        render: function (item, currentValue) {
            console.log('ITEM', item);

            // If we have the content from the result, just use that as the result item
            if('content' in item) {
                const listItem = document.createElement('div');
                listItem.className = 'autocomplete__item';
                listItem.innerHTML = item.content;
                return listItem;
            }

            // else, build the result item from scratch
            const listItem = document.createElement('div');
            listItem.className = 'autocomplete__item';

            const listItemLink = document.createElement('A');
            listItemLink.href = item.url;
            listItemLink.className = 'search-suggestion';

            const itemLabel = document.createElement('SPAN');
            itemLabel.className = 'search-suggestion__title';
            itemLabel.innerHTML = item.title;

            const itemExcerpt = document.createElement('SPAN');
            itemExcerpt.className = 'search-suggestion__excerpt clamp-lines';
            itemExcerpt.innerHTML = item.excerpt;

            listItemLink.appendChild(itemLabel);
            listItemLink.appendChild(itemExcerpt);

            listItem.appendChild(listItemLink);

            return listItem;
        }
    });
}
